import { useState } from "react";
import { PageKonten16 } from './Page16_WO';
import { PageKonten15OdoTd } from "./Page25_UpdateData";
import { PageKonten26Irregular } from "./Page26_Irregular";

//KONTAINER TAB
export function PageKonten15({globalOpsi, authIdentity = {}, token, setPage, resendToken = 0}) {
  const [activeTab, setActiveTab] = useState("tab2");
  const kodeCabangUser = String(authIdentity?.kode_cabang || "").trim();
  const namaUser = String(authIdentity?.nama || "").trim();
  const namaCabang = (
    kodeCabangUser === "C-1"
      ? "Pusat"
      : (
        (Array.isArray(globalOpsi?.opsiCabang) ? globalOpsi.opsiCabang : []).find(
          (x) => String(x?.kode_cabang || "").trim() === kodeCabangUser
        )?.nama_cabang || kodeCabangUser || "-"
      )
  );
  const sharedAuthProps = { authIdentity };
  
  const tabs = [
    { id: "tab2", label: "Work Order/Storing", subtitle: "Transaksi On The Fleet MT dan Ban", accent: "WO/S" },
    { id: "tab3", label: "Update ODO/TD", subtitle: "Pembaruan inspeksi kilometer dan ketebalan", accent: "ODO/TD" },
    { id: "tab4", label: "Irregular Event", subtitle: "Pencatatan kejadian non-rutin MT", accent: "IRR" },
  ];
  const activeTabMeta = tabs.find((tab) => tab.id === activeTab) || tabs[0];

  return (
    <div className="page-con-tabh otf-page">
      <div className="otf-header">
        <div className="otf-header-main">
          <h2 className="otf-title">Aktivitas OTF</h2>
        </div>
        <div className="otf-header-meta">
          <div className="otf-meta-item">
            <small>Cabang</small>
            <strong>{String(namaCabang || "-")}</strong>
          </div>
          <div className="otf-meta-item">
            <small>User</small>
            <strong>{String(namaUser || "-")}</strong>
          </div>
        </div>
      </div>

      <div className="container-con-tabh otf-shell">
        <div className="tabNav-con-tabh otf-tabs">
          {tabs.map(tab => (
            <button
              type="button"
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`otf-tab-btn ${activeTab === tab.id ? "is-active" : ""}`}
            >
              <span className="otf-tab-accent">{tab.accent}</span>
              <span className="otf-tab-copy">
                <strong>{tab.label}</strong>
                <small>{tab.subtitle}</small>
              </span>
            </button>
          ))}
        </div>

        <div className="content-con-tabh otf-content">
          <div className="otf-content-head">
            <div>
              <p className="otf-content-kicker mb-1">Menu Aktif</p>
              <h4 className="otf-content-title mb-1">{activeTabMeta.label}</h4>
              <p className="otf-content-subtitle mb-0">{activeTabMeta.subtitle}</p>
            </div>
          </div>
          {activeTab === "tab2" && (
            <div className="otf-tab-panel">
              <PageKonten16
                token={token}
                {...sharedAuthProps}
                setPage={setPage}
                resendToken={resendToken}
              />
            </div>
          )}
          {activeTab === "tab3" && (
            <div className="otf-tab-panel">
              <PageKonten15OdoTd globalOpsi={globalOpsi} resendToken={resendToken} {...sharedAuthProps} />
            </div>
          )}
          {activeTab === "tab4" && (
            <div className="otf-tab-panel">
              <PageKonten26Irregular
                {...sharedAuthProps}
                globalOpsi={globalOpsi}
                resendToken={resendToken}
                actionScope="without_storing"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
